import React from 'react';
import { DateTime } from 'luxon';
import { Spin } from 'antd';

const currencyFormatter = (value, locale) => {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

function formatDate(date) {
  const time = validateDateDisplayed(date);
  const validatedTime = DateTime.fromJSDate(time);
  const numDate = time.getDate();
  const d = time.getDay();
  const m = time.getMonth();
  const y = time.getFullYear();

  return `${numDate} ${findMonth(m)} ${y} (${findDay(
    d,
  )}) ${validatedTime.toFormat('HH:mm a')}`;
}

function validateDateDisplayed(date) {
  const currentDate = DateTime.now().set({
    hour: 9,
    minute: 0,
    second: 0,
  });
  const jsDate = DateTime.fromJSDate(date);
  const now = DateTime.now();
  const lastDate = DateTime.now().set({
    day: currentDate.day - 1,
    hour: 9,
    minute: 0,
    second: 0,
  });
  if (jsDate.day !== currentDate.day) {
    if (now >= currentDate) {
      date = currentDate.toJSDate();
    } else {
      if (jsDate > lastDate) {
        date = jsDate.toJSDate();
      } else {
        date = lastDate.toJSDate();
      }
    }
  } else {
    date = jsDate.toJSDate();
  }
  return date;
}

function dateDisplayFormatter(date) {
  return formatDate(date);
}

function findDay(d) {
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  return days[d];
}

function findMonth(m) {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  return months[m];
}

const PRODUCT_NAME_MAP = {
  'GOLD - 1g': 'Gold / 1g 黄金价 (1克)',
};

const CustomerTablePreview = ({ liveQuotePrice, updatedAt }) => {
  const productKeys = Object.keys(liveQuotePrice || {});
  if (!liveQuotePrice) {
    return (
      <div style={{ textAlign: 'center', padding: '40px 0' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="jewellery-table">
      <table
        cellSpacing="0"
        cellPadding="5"
        style={{
          marginBottom: '7px',
          color: '#434343',
          border: '0px',
          fontFamily: 'Arial, Helvetica, sans-serif',
          borderSpacing: '0',
          borderCollapse: 'collapse',
          minWidth: '300px',
          maxWidth: '600px',
          maxHeight: '347px',
          fontSize: '12px',
        }}
      >
        <thead>
          <tr
            style={{
              backgroundColor: '#8F206C',
              color: 'white',
              border: '0px',
            }}
          >
            <td
              colSpan="3"
              style={{
                textAlign: 'start',
                height: '20px',
                padding: '5px',
                border: '0px',
                paddingTop: '0px',
                paddingBottom: '0px',
                borderSpacing: '0 0',
                fontWeight: '600',
                fontSize: '11px',
              }}
            >
              REFERENCE PRICE FOR GOLD & SILVER
            </td>
          </tr>
          <tr
            style={{
              backgroundColor: '#D9D2E9',
              color: '#434343',
              border: '0px',
              fontSize: '11px',
            }}
          >
            <th style={{ border: '0px', textAlign: 'left' }}>
              Malaysia Ringgit (MYR)
            </th>
            <th style={{ border: '0px' }}>WE BUY</th>
            <th style={{ border: '0px' }}>WE SELL</th>
          </tr>
        </thead>
        <tbody style={{ fontWeight: '600', fontSize: '11px' }}>
          {productKeys.length === 0 && (
            <tr>
              <td colSpan={3} style={{ textAlign: 'center', color: '#888' }}>
                No data available
              </td>
            </tr>
          )}
          {productKeys.map((key, idx) => {
            const product = liveQuotePrice[key];
            const rowBg =
              idx % 2 === 1
                ? { backgroundColor: '#D9D9D9', border: '0px' }
                : { border: '0px' };
            return (
              <tr key={key} style={rowBg}>
                <td
                  style={{
                    border: '0px',
                    paddingTop: '2px',
                    paddingBottom: '2px',
                  }}
                >
                  {PRODUCT_NAME_MAP[key] || key}
                </td>
                <td
                  style={{
                    textAlign: 'right',
                    border: '0px',
                    paddingTop: '2px',
                    paddingBottom: '2px',
                  }}
                >
                  {product?.IsCutOff
                    ? 'Unavailable'
                    : product?.WeBuy !== undefined && product?.WeBuy != 0
                      ? currencyFormatter(product.WeBuy, 'en-MY')
                      : 'Unavailable'}
                </td>
                <td
                  style={{
                    textAlign: 'right',
                    border: '0px',
                    paddingTop: '2px',
                    paddingBottom: '2px',
                  }}
                >
                  {product?.IsCutOff
                    ? 'Unavailable'
                    : product?.WeSell !== undefined && product?.WeSell != 0
                      ? currencyFormatter(product.WeSell, 'en-MY')
                      : 'Unavailable'}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <label
        style={{
          fontStyle: 'italic',
          fontFamily: 'Arial, Helvetica, sans-serif',
          fontSize: '11px',
          color: '#818181',
        }}
      >
        {updatedAt && `Last Updated On ${dateDisplayFormatter(updatedAt)}`}
      </label>
    </div>
  );
};

export default CustomerTablePreview;
